import React, { useState, useEffect, useReducer } from 'react';

import {
    Box,
    TextField,
    Tooltip,
    FormGroup,
    FormControlLabel,
    Switch,
    Button,
    Paper,
    Typography,
    Divider,
    Alert,
} from "@mui/material";

import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';

import Loading from '../../Loading';
import useNotification from '../../Notification'

import api from '../../../api';

import IntegerOnly from '../../../utils/IntegerOnly';

import './styles.css'
import defaultReducer from '../../../utils/defaultReducer';
import { getSession, saveSession } from '../../../auth';

const Messages = ({ enterpriseId }) => {

    const [state, setState] = useReducer(defaultReducer, {
        default_force_hangup_message: '',
        default_auto_dispatch_message: '',
        has_survey_bypass: false
    })

    const [botTimeoutMessage, setBotTimeoutMessage] = useState({
        var_val: 'Chat encerrado por inatividade.'
    });
    const [chatTimeoutMessage, setChatTimeoutMessage] = useState({
        var_val: 'Chat encerrado por inatividade.'
    });
    const [operatorTimeoutMessage, setOperatorTimeoutMessage] = useState(
        'Chat encerrado por inatividade.'
    );
    const [globalChatTimeoutMessage, setGlobalChatTimeoutMessage] = useState(
        'Chat encerrado por inatividade.'
    );
    const [surveyTimeoutMessage, setSurveyTimeoutMessage] = useState({
        var_val: 'Você não respondeu à pesquisa de satisfação, estamos finalizando seu atendimento.'
    });

    const [ fileNotAllowedMsg, setFileNotAllowedMsg ] = useState(getSession().profile?.enterprise?.settings?.file_not_allowed_msg ?? "")

    const [queueTimeoutMessage, setQueueTimeoutMessage] = useState('Chat encerrado pelo sistema.')

    const [botTimeoutTime, setBotTimeoutTime] = useState(0)
    const [chatTimeoutTime, setChatTimeoutTime] = useState(0)
    const [operatorTimeoutTime, setOperatorTimeoutTime] = useState(0)
    const [globalChatTimeoutTime, setGlobalChatTimeoutTime] = useState(0)
    const [globalTimeoutEnabled, setGlobalTimeoutEnabled] = useState(false)
    const [crossTimeoutEnabled, setCrossTimeoutEnabled] = useState(false)
    const [surveyTimeoutTime, setSurveyTimeoutTime] = useState(0)
    const [queueTimeoutTime, setQueueTimeoutTime] = useState(0)
    const [chatQuarantine, setChatQuarantine] = useState(130)

    const [loading, setLoading] = useState(true);
    const [patchLoading, setPatchLoading] = useState(false);

    const getMessagesAndTimes = async () => {
        setLoading(true)
        const url = `api/enterprises/${enterpriseId}/config/`;
        const res = await api.get(url);

        if (res.status == 200) {
            res.data.forEach((config) => {
                switch (config.var_name) {
                    case 'bot_timeout':
                        setBotTimeoutTime(config.var_val)
                        break
                    case 'bot_timeout_message':
                        setBotTimeoutMessage(config.var_val);
                        break
                    case 'chat_timeout':
                        setChatTimeoutTime(config.var_val)
                        break
                    case 'chat_timeout_message':
                        setChatTimeoutMessage(config.var_val);
                        break
                    case 'operator_timeout':
                        setOperatorTimeoutTime(config.var_val);
                        break
                    case 'operator_timeout_message':
                        setOperatorTimeoutMessage(config.var_val);
                        break
                    case 'global_chat_timeout':
                        setGlobalChatTimeoutTime(config.var_val);
                        if (config.var_val)
                            setGlobalTimeoutEnabled(true);
                        break
                    case 'global_chat_timeout_message':
                        setGlobalChatTimeoutMessage(config.var_val);
                        break
                    case 'cross_timeout':
                        if (config.var_val)
                            setCrossTimeoutEnabled(true);
                        break
                    case 'survey_timeout_message':
                        setSurveyTimeoutMessage(config.var_val);
                        break
                    case 'survey_timeout':
                        setSurveyTimeoutTime(config.var_val)
                        break;
                    case 'queue_timeout':
                        setQueueTimeoutTime(config.var_val)
                        break
                    case 'queue_timeout_message':
                        setQueueTimeoutMessage(config.var_val)
                        break
                    case 'default_force_hangup_message':
                        setState({ default_force_hangup_message: config.var_val })
                        break;
                    case 'default_auto_dispatch_message':
                        setState({ default_auto_dispatch_message: config.var_val })
                        break;
                    case 'has_survey_bypass':
                        setState({ has_survey_bypass: config.var_val })
                        break;
                    case 'chat_quarantine':
                        setChatQuarantine(config.var_val)
                        break;
                    default:
                        break
                }
            });
        }
        else {
            useNotification(
                'Ops!',
                'Ocorreu um erro ao carregar as mensagens.',
                'danger'
            );
        }

        setLoading(false)
    }

    const patchALL = async () => {
        setPatchLoading(true);
        const res = await Promise.all([patchConfigs(), patchSettings()])
        setPatchLoading(false);

        const result = res.reduce((x, y) => x == 200 && y == 200)

        if (!result) {
            useNotification(
                'Ops!',
                'Ocorreu um erro ao salvar as mensagens.',
                'danger'
            );
        } else {
            useNotification(
                'Sucesso!',
                'As mensagens foram salvas com sucesso.',
                'success'
            );
        }
    }

    const checkNullTime = async (data) => {
        if (data.bot_timeout === "" || data.chat_timeout === "" || data.survey_timeout === "" || data.queue_timeout === "") {
            useNotification("Ops!", "O tempo de timeout não pode ser vazio.", "warning")
            return false
        }
        return true
    }

    const patchSettings = async () => {
        const response = await api.patch(`api/enterprises/${enterpriseId}/`, {
            settings: {
                file_not_allowed_msg: fileNotAllowedMsg
            }
        })
        if (response.status === 200) {
            const session = getSession()
            session.profile.enterprise.settings.file_not_allowed_msg = fileNotAllowedMsg
            saveSession(session)
        }
        return response.status
    }

    const patchConfigs = async () => {
        const data = {
            'bot_timeout': botTimeoutTime,
            'bot_timeout_message': botTimeoutMessage,
            'chat_timeout': chatTimeoutTime,
            'chat_timeout_message': chatTimeoutMessage,
            'operator_timeout': operatorTimeoutTime,
            'operator_timeout_message': operatorTimeoutMessage,
            'global_chat_timeout': globalTimeoutEnabled
                ? globalChatTimeoutTime
                : 0,
            'global_chat_timeout_message': globalChatTimeoutMessage,
            'survey_timeout_message': surveyTimeoutMessage,
            'survey_timeout': surveyTimeoutTime,
            'queue_timeout': queueTimeoutTime,
            'queue_timeout_message': queueTimeoutMessage,
            'default_force_hangup_message': state.default_force_hangup_message,
            'default_auto_dispatch_message': state.default_auto_dispatch_message,
            'has_survey_bypass': state.has_survey_bypass,
            'chat_quarantine': chatQuarantine,
            'cross_timeout': crossTimeoutEnabled,
        }

        if (!await checkNullTime(data))
            return false

        const base_url = `api/enterprises/${enterpriseId}/config/updatedata/`;

        const res = await api.patch(base_url, data);

        const session = getSession()
        session.profile.enterprise.settings = { ...session.profile.enterprise.settings, ...data }
        saveSession(session)
        return res.status
    }

    useEffect(() => {
        getMessagesAndTimes();
    }, [])

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            
            <Loading loading={loading} />
            <Box>
                <Paper variant="outlined" sx={{ p: 3 }}>
                    <Typography variant="h6">
                        Mensagens
                    </Typography>

                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 0.5, mb: 2 }}
                    >
                        Personalize as mensagens enviadas automaticamente aos contatos para cada situação.
                    </Typography>

                    <Box className="messages-flexbox push-bottom">
                        <TextField
                            fullWidth
                            multiline
                            maxRows={4}
                            size="small"
                            label="Finalização de atendimentos no chatbot ou em fila"
                            placeholder={`Mensagem ${state.default_force_hangup_message.length}/5000`}
                            type="text"
                            variant="outlined"
                            value={state.default_force_hangup_message}
                            onChange={(event) => setState({ default_force_hangup_message: event.target.value })}
                            inputProps={{
                                maxLength: 5000
                            }}
                        />
                    </Box>

                    <Box className="messages-flexbox push-bottom">
                        <TextField
                            fullWidth
                            multiline
                            maxRows={4}
                            size="small"
                            label="Arquivos enviados durante o chatbot (não suportado)"
                            placeholder={`Mensagem ${state.default_force_hangup_message.length}/1024`}
                            type="text"
                            variant="outlined"
                            value={fileNotAllowedMsg}
                            onChange={(event) => setFileNotAllowedMsg(event.target.value)}
                            inputProps={{
                                maxLength: 1024
                            }}
                        />
                    </Box>

                    <Box className="messages-flexbox push-bottom">
                        <TextField
                            fullWidth
                            multiline
                            maxRows={4}
                            size="small"
                            label="Distribuição automática de atendimentos (DAC)"
                            placeholder={`Mensagem ${state.default_auto_dispatch_message.length}/5000`}
                            type="text"
                            variant="outlined"
                            value={state.default_auto_dispatch_message}
                            onChange={(event) => setState({ default_auto_dispatch_message: event.target.value })}
                            inputProps={{
                                maxLength: 5000
                            }}
                        />
                    </Box>
                </Paper>

                <Paper variant="outlined" sx={{ p: 3, mt: 2 }}>
                    <Typography variant="h6">
                        Timeouts
                    </Typography>

                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 0.5, mb: 2 }}
                    >
                        Configure quando atendimentos serão encerrados automaticamente por inatividade, e quais mensagens serão enviadas aos contatos.
                    </Typography>

                    <Divider sx={{ mt: 3, mb: 1.5 }} />

                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        sx={{ mb: 2 }}
                    >
                        Chatbot
                    </Typography>

                    <Box className="messages-flexbox">
                        <Tooltip title='Número entre 10 e 86400'>
                            <TextField
                                sx={{ flex: 0.15 }}
                                size="small"
                                multiline
                                label="Tempo (segundos)"
                                type="text"
                                variant="outlined"
                                value={botTimeoutTime}
                                onChange={(event) => setBotTimeoutTime(IntegerOnly(event.target.value, 1, 86400))}
                                onBlur={(event) => setBotTimeoutTime(IntegerOnly(event.target.value, 10, 86400))}
                            />
                        </Tooltip>
                        <TextField
                            sx={{ flex: 0.85 }}
                            size="small"
                            multiline
                            label="Mensagem"
                            fullWidth
                            type="text"
                            variant="outlined"
                            value={botTimeoutMessage}
                            onChange={(event) => setBotTimeoutMessage(event.target.value)}
                        />
                    </Box>

                    <Divider sx={{ mt: 3, mb: 1.5 }} />

                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        sx={{ mb: 2 }}
                    >
                        Em fila
                    </Typography>

                    <Box className="messages-flexbox">
                        <Tooltip title='Número entre 10 e 604800'>
                            <TextField
                                sx={{ flex: 0.15 }}
                                size="small"
                                multiline
                                label="Tempo (segundos)"
                                type="text"
                                variant="outlined"
                                value={queueTimeoutTime}
                                onChange={(event) => setQueueTimeoutTime(IntegerOnly(event.target.value, 1, 604800))}
                                onBlur={(event) => setQueueTimeoutTime(IntegerOnly(event.target.value, 10, 604800))}
                            />
                        </Tooltip>
                        <Tooltip title='As mensagens de timeout em fila só serão enviadas se o timeout for menor que 24h (86400s)'>
                            <TextField
                                sx={{ flex: 0.85 }}
                                size="small"
                                multiline
                                label="Mensagem"
                                fullWidth
                                type="text"
                                disabled={queueTimeoutTime > 86400}
                                variant="outlined"
                                value={queueTimeoutMessage}
                                onChange={(event) => setQueueTimeoutMessage(event.target.value)}
                                inputProps={{
                                    maxlength: 255
                                }}
                            />
                        </Tooltip>
                    </Box>

                    <Divider sx={{ mt: 3, mb: 1.5 }} />

                    <Typography variant="subtitle1" fontWeight={600}>
                        Em atendimento
                    </Typography>

                    <Alert severity="info" sx={{ my: 1 }}>
                        <strong>A inatividade dos chats em atendimento pode ser controlada de 3 formas:</strong>

                        <ol>
                            <li style={{ marginBottom: "5px" }}>
                                <strong>Inatividade global:</strong>{' '}
                                cada mensagem, quer seja do contato ou do operador, reinicia o contador.
                                Se nenhuma mensagem for enviada durante o período configurado, o atendimento será encerrado automaticamente.
                            </li>

                            <li style={{ marginBottom: "5px" }}>
                                <strong>Inatividade cruzada:</strong>{' '}
                                a mensagem de um participante inicia o contador para o outro responder.
                                Se o cliente enviar uma mensagem, o operador terá o tempo configurado para responder.
                                Se o operador enviar uma mensagem, o cliente terá o tempo configurado para responder.
                                Caso não haja resposta dentro do prazo, o atendimento será encerrado automaticamente.
                            </li>

                            <li style={{ marginBottom: "5px" }}>
                                <strong>Inatividade independente:</strong>{' '}
                                cada participante possui seu próprio contador.
                                As mensagens do cliente reiniciam o contador do cliente, enquanto as mensagens do operador reiniciam o contador do operador.
                                Se o participante não enviar uma nova mensagem dentro do prazo configurado, o atendimento será encerrado automaticamente.
                            </li>
                        </ol>
                    </Alert>

                    <FormControlLabel
                        control={
                            <Switch
                                checked={globalTimeoutEnabled}
                                onChange={(e) => {
                                    const enabled = e.target.checked;
                                    setGlobalTimeoutEnabled(enabled);
                                    if (enabled && globalChatTimeoutTime === 0)
                                        setGlobalChatTimeoutTime(86400)
                                }}
                            />
                        }
                        label="Inatividade do atendimento"
                        sx={{ mb: 1 }}
                    />

                    {!globalTimeoutEnabled &&
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={crossTimeoutEnabled}
                                    onChange={() => setCrossTimeoutEnabled(!crossTimeoutEnabled)}
                                />
                            }
                            label="Inatividade cruzada"
                            sx={{ mb: 1 }}
                        />
                    }

                    {globalTimeoutEnabled ? (
                        <Box className="messages-flexbox">
                            <Tooltip title='Número entre 10 e 86400'>
                                <TextField
                                    sx={{ flex: 0.15 }}
                                    size="small"
                                    multiline
                                    label="Tempo (segundos)"
                                    type="text"
                                    variant="outlined"
                                    value={globalChatTimeoutTime}
                                    onChange={(event) => setGlobalChatTimeoutTime(IntegerOnly(event.target.value, 1, 86400))}
                                    onBlur={(event) => setGlobalChatTimeoutTime(IntegerOnly(event.target.value, 10, 86400))}
                                />
                            </Tooltip>
                            <TextField
                                sx={{ flex: 0.85 }}
                                size="small"
                                multiline
                                label="Mensagem"
                                fullWidth
                                type="text"
                                variant="outlined"
                                value={globalChatTimeoutMessage}
                                onChange={(event) => setGlobalChatTimeoutMessage(event.target.value)}
                            />
                        </Box>
                    ) : (
                        <>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                Inatividade do contato
                            </Typography>

                            <Box className="messages-flexbox">
                                <Tooltip title='Número entre 10 e 86400'>
                                    <TextField
                                        sx={{ flex: 0.15 }}
                                        size="small"
                                        multiline
                                        label="Tempo (segundos)"
                                        type="text"
                                        variant="outlined"
                                        value={chatTimeoutTime}
                                        onChange={(event) => setChatTimeoutTime(IntegerOnly(event.target.value, 1, 86400))}
                                        onBlur={(event) => setChatTimeoutTime(IntegerOnly(event.target.value, 10, 86400))}
                                    />
                                </Tooltip>
                                <TextField
                                    sx={{ flex: 0.85 }}
                                    size="small"
                                    multiline
                                    label="Mensagem"
                                    fullWidth
                                    type="text"
                                    variant="outlined"
                                    value={chatTimeoutMessage}
                                    onChange={(event) => setChatTimeoutMessage(event.target.value)}
                                />
                            </Box>
                            
                            <Typography variant="subtitle2" sx={{ mt: 3, mb: 1 }}>
                                Inatividade do operador
                            </Typography>

                            <Box className="messages-flexbox">
                                <Tooltip title='Número entre 10 e 86400'>
                                    <TextField
                                        sx={{ flex: 0.15 }}
                                        size="small"
                                        multiline
                                        label="Tempo (segundos)"
                                        type="text"
                                        variant="outlined"
                                        value={operatorTimeoutTime}
                                        onChange={(event) => setOperatorTimeoutTime(IntegerOnly(event.target.value, 1, 86400))}
                                        onBlur={(event) => setOperatorTimeoutTime(IntegerOnly(event.target.value, 10, 86400))}
                                    />
                                </Tooltip>
                                <TextField
                                    sx={{ flex: 0.85 }}
                                    size="small"
                                    multiline
                                    label="Mensagem"
                                    fullWidth
                                    type="text"
                                    variant="outlined"
                                    value={operatorTimeoutMessage}
                                    onChange={(event) => setOperatorTimeoutMessage(event.target.value)}
                                />
                            </Box>
                        </>
                    )}

                    <Divider sx={{ mt: 3, mb: 1.5 }} />

                    <Typography variant="subtitle1" fontWeight={600}>
                        Pesquisa de satisfação
                    </Typography>

                    <FormControlLabel
                        control={
                            <Switch
                                color="primary"
                                checked={state.has_survey_bypass}
                                onChange={() => setState({has_survey_bypass: !state.has_survey_bypass})}
                            />
                        }
                        label="Permitir finalizar conversas sem passar pela pesquisa de satisfação"
                        sx={{ mb: 1 }}
                    />

                    <Box className="messages-flexbox">
                        <Tooltip title='Número entre 10 e 86400'>
                            <TextField
                                sx={{ flex: 0.15 }}
                                size="small"
                                multiline
                                label="Tempo (segundos)"
                                type="text"
                                variant="outlined"
                                value={surveyTimeoutTime}
                                onChange={(event) => setSurveyTimeoutTime(IntegerOnly(event.target.value, 1, 86400))}
                                onBlur={(event) => setSurveyTimeoutTime(IntegerOnly(event.target.value, 10, 86400))}
                            />
                        </Tooltip>
                        <TextField
                            sx={{ flex: 0.85 }}
                            size="small"
                            multiline
                            label="Mensagem"
                            fullWidth
                            type="text"
                            variant="outlined"
                            value={surveyTimeoutMessage}
                            onChange={(event) => setSurveyTimeoutMessage(event.target.value)}
                        />
                    </Box>
                </Paper>



                <Paper variant="outlined" sx={{ p: 3, mt: 2 }}>
                    <Typography variant="h6">
                        Quarentena
                    </Typography>

                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 0.5, mb: 2 }}
                    >
                        A quarentena é útil para atendimentos que foram desligados automaticamente por inatividade da pesquisa de satisfação, evitando que a resposta posterior inicie um novo atendimento.
                    </Typography>

                    <Box className="messages-flexbox">
                        <Tooltip title='Número entre 0 (desativado) e 86400.'>
                            <TextField
                                sx={{ flex: 0.15 }}
                                size="small"
                                multiline
                                label="Tempo (segundos)"
                                type="text"
                                variant="outlined"
                                value={chatQuarantine}
                                onChange={(event) => setChatQuarantine(IntegerOnly(event.target.value, 0, 86400))}
                                onBlur={(event) => setChatQuarantine(IntegerOnly(event.target.value, 0, 86400))}
                            />
                        </Tooltip>
                    </Box>
                </Paper>
            </Box>
            <LoadingButton
                style={{ width: 'fit-content' }}
                onClick={patchALL}
                loading={patchLoading}
                loadingPosition="start"
                startIcon={<SaveIcon />}
                variant="contained"
            >
                Salvar
            </LoadingButton>
        </Box>
    )
}

export default Messages
